export var DataExportFormat;
(function (DataExportFormat) {
    DataExportFormat["Json"] = "JSON";
    DataExportFormat["JsonEachRow"] = "JSONEachRow";
    DataExportFormat["Csv"] = "CSV";
    DataExportFormat["CsvWithNames"] = "CSVWithNames";
    DataExportFormat["Invalid"] = "INVALID";
})(DataExportFormat || (DataExportFormat = {}));
//# sourceMappingURL=data-export.format.js.map